import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { Constants } from '../../../../core/services/constants';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
  username: string;
  seeNewPassword: Boolean;
  seeConfPassword: Boolean;
  newPasswordForm: FormGroup;
  statusMessage: string;
  verificationCodeInputError = false;
  newPasswordInputError = false;
  newPasswordError = false;
  processComplete = false;
  loading = false;

  fileNameDialogRef: MatDialogRef<ErrorDialogComponent>;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private dialog: MatDialog) { }

  openDialog(errorMessage: string): void {
    this.fileNameDialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        errorMsg: errorMessage
      },
      autoFocus: false,
      panelClass: 'errorPopup'
    });
  }

  ngOnInit() {
    this.username = this.route.snapshot.queryParams.username;
    this.newPasswordForm = new FormGroup({
      verificationCode: new FormControl('', Validators.nullValidator && Validators.required),
      newPassword: new FormControl('', Validators.nullValidator && Validators.required),
      confirmPassword: new FormControl('', Validators.nullValidator && Validators.required),
    });
  }

  onNewPassword(form: NgForm) {

    if (form.value.newPassword !== form.value.confirmPassword) {

      this.statusMessage = Constants.MSG.PWDS_DONT_MATCH;
      this.newPasswordInputError = true;
      this.newPasswordError = true;

    } else if (!(Constants.REGEX.PASSWORD_REGEX.test(form.value.newPassword))) {

      this.statusMessage = Constants.MSG.PWD_RESTRICTIONS;
      this.newPasswordInputError = true;
      this.newPasswordError = true;
    } else {
      this.loading = true;
      this.username = this.username ? this.username : 'dummy';
      this.loginService.setNewPassword(this.username, form.value.verificationCode, form.value.newPassword)
        .finally(() => {
          this.loading = false;
        })
        .subscribe(
          res => {
            this.statusMessage = Constants.MSG.PWD_CHANGED;
            this.newPasswordError = false;
            this.processComplete = true;
          },
          err => {
            if (err.message === Constants.MSG.INVALID_VERIFICATION_CODE) {
              this.verificationCodeInputError = true;
              this.newPasswordError = true;
              this.statusMessage = err.message;
            } else {
              this.openDialog(err.message);
            }
          }
        );
    }
  }

  cleanForm() {
    if (this.newPasswordError) {
      this.verificationCodeInputError = false;
      this.newPasswordError = false;
      this.newPasswordInputError = false;
      this.statusMessage = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/new-password/new-password.component.ts